const SITE_URL = "https://plataformaciudadanadefosas.org/";
const SITE_NAME = "Plataforma Ciudadana de Fosas";
const DEFAULT_IMAGE = `${SITE_URL}assets/og-image.png`;

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function setTitle(title) {
  document.title = title;
}

export function applySeo({
  title,
  description,
  path = "/",
  image,
  noindex = false
} = {}) {
  const pageTitle = title ? title : SITE_NAME;
  const pageUrl = new URL(path, SITE_URL).href;
  const pageImage = image ? new URL(image, SITE_URL).href : DEFAULT_IMAGE;

  setTitle(pageTitle);
  setLink("canonical", pageUrl);

  setMeta("name", "description", description);
  setMeta(
    "name",
    "robots",
    noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large"
  );

  setMeta("property", "og:type", "website");
  setMeta("property", "og:site_name", SITE_NAME);
  setMeta("property", "og:locale", "es_MX");
  setMeta("property", "og:title", pageTitle);
  setMeta("property", "og:description", description);
  setMeta("property", "og:url", pageUrl);
  setMeta("property", "og:image", pageImage);
  setMeta("property", "og:image:alt", SITE_NAME);

  setMeta("name", "twitter:card", "summary_large_image");
  setMeta("name", "twitter:title", pageTitle);
  setMeta("name", "twitter:description", description);
  setMeta("name", "twitter:image", pageImage);
}

export default applySeo;
